import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Helmet } from 'react-helmet';
import { Route } from 'react-router-dom';
import { Slot } from 'react-slot-fill';
import { connect } from 'react-redux';
import styles from './DashboardLayout.css';
import appStyles from '../styles/app.css';
import Header from '../Components/Header';
import ScrollToTopOnLocationChange from '../Components/ScrollToTopOnLocationChange';
import SITE_MODES from '../../constants/site-modes';

const DashboardLayout = ({
    component: Component,
    title,
    showBackground,
    siteMode,
    handleScroll,
    ...other
}) => (<Route
    {...other}
    render={matchProps => (<div
        className={cx(styles.container, {
            [appStyles.bg]: showBackground && siteMode === SITE_MODES.EDUCATION,
        })}
    >
        <div>
            <Helmet>
                <title>
                    {siteMode === SITE_MODES.EDUCATION ? 'PathwayU' : 'jobZology'}
                    {title ? ` | ${title}` : ''}
                </title>
            </Helmet>
            <Slot name="Header">
                {slots => (slots.length === 0 ?
                    <Header location={matchProps.location} /> : slots[0]
                )}
            </Slot>
            <main id="main_content">
                <Component {...matchProps} />
            </main>
            {handleScroll && <ScrollToTopOnLocationChange
                location={`${matchProps.location.pathname}${matchProps.location.search}`}
                handleScroll={handleScroll}
            />}
            <Slot name="Dashboard" />
        </div>
    </div>)}
/>);

DashboardLayout.propTypes = {
    children: PropTypes.node,
    title: PropTypes.string,
    component: PropTypes.func,
    showBackground: PropTypes.bool,
    handleScroll: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
    ]),
    siteMode: PropTypes.number,
};

DashboardLayout.defaultProps = {
    handleScroll: true,
};

export default connect(({ theme }) => ({
    siteMode: theme.siteMode,
}))(DashboardLayout);



// WEBPACK FOOTER //
// ./src/client/Layouts/DashboardLayout.js